import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import ShikaLogo from "./ShikaLogo";

const TypingIndicator = () => {
    return (
        <Box sx={{ 
            display: "flex", 
            alignItems: "flex-start",
            p: 1,
            gap: 1
        }}>
            <Avatar 
                sx={{ 
                    width: 38, 
                    height: 38,
                    bgcolor: "transparent",
                    p: 0.5
                }}
            >
                <ShikaLogo size={30} />
            </Avatar>

            <Box sx={{ 
                display: "flex",
                alignItems: "center",
                bgcolor: "background.paper",
                borderRadius: 2,
                borderTopLeftRadius: 0.5,
                p: 1.5,
                boxShadow: 1
            }}>
                <Typography 
                    variant="body2" 
                    color="text.secondary"
                    sx={{ mr: 1 }}
                >
                    Shika is thinking
                </Typography>

                {/* Animated dots */}
                <Box sx={{ display: "flex", gap: 0.5 }}>
                    {[0, 1, 2].map((index) => (
                        <Box
                            key={index}
                            sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                bgcolor: "primary.main",
                                animation: "typing-dot 1.4s infinite ease-in-out",
                                animationDelay: `${index * 0.16}s`,
                                "@keyframes typing-dot": {
                                    "0%, 80%, 100%": {
                                        transform: "scale(0)",
                                        opacity: 0.5
                                    },
                                    "40%": {
                                        transform: "scale(1)",
                                        opacity: 1
                                    }
                                }
                            }}
                        />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default TypingIndicator; 